<template>
  <div id="app" style="height:100%">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  @import "css/flex.css";
  @import "css/ripple.css";

  /* @font-face {
    font-family: 'myFont';
    src: url('/font/PingFangSC-Light.ttf');
    font-weight: normal;
    font-style: normal;
  } */

  body, html {
    /* font-family: PingFangSC-Medium, sans-serif; */
    background-color: white;
    font-weight: normal;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue